import script from "./NavContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavContent.vue?vue&type=script&setup=true&lang=ts"

import "./NavContent.vue?vue&type=style&index=0&id=6b879769&scoped=true&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b879769"]])

export default __exports__